/* unplugin-vue-components disabled */
export default {
  props: {
    file: {
      type: Object,
      required: true
    },
  },
  emits: ['delete', 'download', 'edit'],
  computed: {
    name() {
      return this.file.name
    },
    size() {
      const file_size = this.file.size || 0
      return $utils.format.bytes(file_size)
    },
    ext() { 
      return this.name?.split('.').pop()
    },
  },
}
